import React from "react";
import {
  AppBar,
  Avatar,
  IconButton,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useSelector } from "react-redux";
import { Container } from "@mui/system";
import "./style.css";
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { themeOrange } from "../../utils/colorTheme";

export const UserTopAppBar = ({ onClickHanlde }) => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.userAuth);

  return (
    <Stack zIndex={1001}>
      <AppBar
        elevation={0}
        className={`topBarStyle`}
        sx={{
          backgroundColor: "#fff",
          width: "100%",
          height: 64,
          borderBottom: "1px solid #f0f0f0",
        }}
        position="static"
      >
        <Toolbar sx={{ px: 3, minHeight: "64px !important" }}>
          <Stack
            alignItems="center"
            sx={{ width: "100%" }}
            direction="row"
            justifyContent="space-between"
          >
            <IconButton
              onClick={onClickHanlde}
              size="small"
              edge="start"
              sx={{ color: "#555" }}
              aria-label="menu"
            >
              <MenuIcon
                sx={{
                  display: {
                    xl: "none",
                    lg: "none",
                    md: "none",
                    sm: "flex",
                    xs: "flex",
                  },
                }}
              />
            </IconButton>

            <Container disableGutters maxWidth="xl">
              <Stack
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                gap={2}
              >
                <Stack
                  onClick={() => navigate("/")}
                  direction="row"
                  alignItems="center"
                  sx={{
                    borderRadius: "12px",
                    border: "1px solid #f0f0f0",
                    overflow: "hidden",
                    cursor: "pointer",
                    transition: "all 0.15s",
                    "&:hover": { borderColor: "#ddd", bgcolor: "#FAFAFA" },
                    py: 0.5,
                    pl: 0.5,
                    pr: 1.5,
                  }}
                  gap={1}
                >
                  <Avatar
                    src={user?.avatar || ""}
                    sx={{
                      width: 34,
                      height: 34,
                      borderRadius: "10px",
                      bgcolor: themeOrange,
                      fontSize: "13px",
                      fontWeight: 600,
                    }}
                  >
                    {user?.first_name?.[0]}
                  </Avatar>
                  <Typography
                    sx={{
                      color: "#333",
                      fontSize: "13px",
                      fontWeight: 600,
                    }}
                  >
                    {user?.first_name || ""}
                  </Typography>
                  <IoIosArrowForward style={{ fontSize: "14px", color: "#999" }} />
                </Stack>
              </Stack>
            </Container>
          </Stack>
        </Toolbar>
      </AppBar>
    </Stack>
  );
};
